import React from "react"
import { Text, Link } from "dash-styled"

export const ConsentStatement = () => {
    return (
        <Text color="gray" component="div" className="text-center py-12">
            By signing up, you agree to our{" "}
            <Link
                target="_blank"
                to={`${process.env.PUBLIC_URL}/terms_of_service.pdf`}
            >
                Terms and Conditions
            </Link>{" "}
            and acknowledge our{" "}
            <Link
                target="_blank"
                to={`${process.env.PUBLIC_URL}/privacy_policy.pdf`}
            >
                Privacy Policy
            </Link>
            .
        </Text>
    )
}
